<div class="input-block select">
  <select
    [name]="name"
    [ngClass]="{'input-block--full input-block--valid': selectedItem && placeholder}"
    [id]="'select-' + name"
    [ngModel]="selectedItem"
    (ngModelChange)="valueChange($event)">
      <option [ngValue]="undefined" selected>{{placeholder}}</option>
      <option *ngFor="let option of options"
        [value]="option.value">
        {{option.label}}
      </option>
  </select>

  <span
    class="centum-icons-check select__success-icon"
    [ngClass]="{'select__success-icon--active': selectedItem && placeholder}"></span>
</div>